import { Loader } from 'lucide-react';

interface DataTableLoadMoreCellProps {
  /** Accessible label for the spinner (caller resolves i18n). */
  label?: string;
}

/**
 * Inline "loading more" content for a full-width table row (render via `DataTable`'s
 * `renderFullWidthRow`). Centers a spinner horizontally across the table width and matches
 * a normal row's height.
 */
export function DataTableLoadMoreCell({ label }: DataTableLoadMoreCellProps) {
  return (
    <div className="flex h-6 w-full items-center justify-center">
      <Loader className="h-4 w-4 animate-spin text-muted-foreground" aria-label={label} />
    </div>
  );
}
